import activateDidYouMean from '../includes/email-suggestion.js';
import reCAPTCHA from '../includes/recaptcha.js';

export default function initOptinForm(formSelector = '.order-form-trial') {
	const forms = document.querySelectorAll(formSelector);

	forms.forEach(function(el) {
		const form = $(el);
		const button = form.find(':submit');

		const recaptchaChallenge = new reCAPTCHA(el);

		if (recaptchaChallenge.isRequired()) {
			recaptchaChallenge.init();
		}

		form.on('submit', async function(e, doSubmit) {
			if (doSubmit) {
				return;
			}

			e.preventDefault();

			const data = form.serializeJSON();

			const action = form.data('action');
			const email = form.find('[type="email"]');

			button.button('loading');

			data.form = action;
			data.email = email.val();
			data.skip_email_check = form.data('skip_email_check');

			if (recaptchaChallenge.isInit()) {
				if (!recaptchaChallenge.isValid()) {
					alert('Please complete the challenge. (3)');

					button.button('reset');

					return;
				}
			} else {
				await reCAPTCHA.addToken(data);
			}

			try {
				const { searchParams } = new URL(location);
				if (searchParams.get('utm_source') === 'homepage' && searchParams.get('utm_medium') === '7daytrialbutton') {
					data['tag_from'] = 'front_page_7_day_trial';
				}
			} catch(e) {
				console.log(e);
			}

			ajax('leads', data, async function(res) {
				await gtmEvent('sign_up', { method: action });

				form.trigger('submit', [ true ]);
				button.button('reset');
			}, function(res) {
				button.button('reset');

				if (res.hasOwnProperty('did_you_mean')) {
					activateDidYouMean(form, email.val(), res.did_you_mean);
				}

				recaptchaChallenge.handleResponse(res);
			});
		});
	});
}
